var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7285 5.27516C13.7285 7.40004 12.0059 9.12259 9.88103 9.12259C7.75615 9.12259 6.0336 7.40004 6.0336 5.27516C6.0336 3.15029 7.75615 1.42773 9.88103 1.42773C12.0059 1.42773 13.7285 3.15029 13.7285 5.27516ZM17.5045 15.6061C16.4946 12.462 13.8985 10.8757 9.88104 10.8757C5.86355 10.8757 3.26213 12.462 2.2512 15.6061C2.14208 15.9468 2.11512 16.3085 2.17226 16.6617C2.22939 17.0149 2.36903 17.3496 2.58002 17.6385C2.79101 17.9275 3.0673 18.1625 3.38632 18.3245C3.70534 18.4865 4.05806 18.5708 4.41585 18.5706H15.3337L15.51 18.5643C15.8522 18.5382 16.1842 18.435 16.4808 18.2624C16.7775 18.0898 17.0312 17.8524 17.2231 17.5678C17.4149 17.2832 17.5398 16.9589 17.5885 16.6192C17.6373 16.2795 17.6086 15.9331 17.5045 15.6061Z",
    fill: "#93AAC8"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.933cb7c30d3cddb69933faa7c097d197.svg";
export { ForwardRef as ReactComponent };